import React, { Component,useEffect } from "react";
import BookingComponent from './components/BookingComponent';

import PropTypes from 'prop-types';
import BookingAPIService from "../API/BookingAPI";



export class BookingContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            tableData:[],
            loaded:false,
            formFilled:false,
            date: new Date(),
            partySize:0,
            areaId:"",
        }

        this.updateTableData = this.updateTableData.bind(this);
        this.updateLoaded = this.updateLoaded.bind(this);
        this.updateFormFilled = this.updateFormFilled.bind(this);

    }

    updateTableData(fetched){
        this.setState({tableData:fetched});
    }
    updateLoaded(loaded){
        this.setState({loaded:loaded});
    }
    updateFormFilled(filled){
        this.setState(filled);
    }


    render(){

        return(
            <BookingComponent 
                formFilled={this.state.formFilled} updateFormFilled={this.updateFormFilled}
                loaded={this.state.loaded} updateLoaded={this.updateLoaded}
                tableData={this.state.tableData} updateTableData={this.updateTableData}
            />
        )
    }
          
        
}

BookingContainer.defaultProps={

}
BookingContainer.propTypes = {

}

export default(BookingContainer);